export const getShortLanguageCode = (language: string) => language.substr(0, 2);
